import React, { memo } from 'react';
import { StyleSheet, View } from 'react-native';
import { ToolTip } from 'design-system';
import Spacer from 'design-system/Spacer';
import Text from 'design-system/Text';
import BlurAmountView from 'design-system/BlurAmountView';
import { rem } from 'design-system/values';
import { formatAmount } from 'utils/formatting';
import { useAppSelector } from 'store/hooks';
import { formatNumberOfShares } from '../utils';
/**
 * Use `altTooltipSpacing` for the Account screen.
 */
const RowAmount = (props) => {
    const scrambled = useAppSelector((store) => store.utils.scrambled);
    const { testID, bold, title, subtitleLeft, subtitleRight, showCents, noPaddingHorizontal, noBottomLine, est, tableSpacing, tootTipBtnText, altTooltipSpacing, toolTipExtraBtnText, toolTipOnExtraBtnPress, } = props;
    let value;
    if ('amount' in props) {
        value = formatAmount(props.amount.value, props.amount.currency, showCents ? 2 : undefined);
    }
    else {
        value = formatNumberOfShares(props.quantity, false);
    }
    return (<>
      <View testID={testID} style={[styles.container, noPaddingHorizontal && styles.noPaddingHorizontal]}>
        <View style={styles.row}>
          {bold ? (<Text {...(!tableSpacing ? { 'Text-16': true } : { 'Text-14': true })} numberOfLines={1}>
              {title}
            </Text>) : (<Text {...(!tableSpacing ? { 'TextThin-16': true } : { 'TextThin-14': true })} Secondary numberOfLines={1}>
              {title}
            </Text>)}
          {est ? (<Text {...(!tableSpacing ? { 'TextThin-16': true } : { 'TextThin-14': true })} Secondary>
              {` (est.)`}
            </Text>) : null}
          <Spacer w={altTooltipSpacing ? 8 : 4}/>
          {'tooltipText' in props && Boolean(props.tooltipText) && (<ToolTip tootTipBtnText={tootTipBtnText} toolTipExtraBtnText={toolTipExtraBtnText} onExtraBtnPress={toolTipOnExtraBtnPress} title={props.tooltipTitle} subtitle={props.tooltipText} colorKey="secondary" small offset={2}/>)}
          <Spacer flex/>
          <BlurAmountView enabled={scrambled}>
            <Text {...(!tableSpacing ? { 'Numbers-16': true } : { 'Numbers-14': true })}>{value}</Text>
          </BlurAmountView>
        </View>
        {(!!subtitleLeft || !!subtitleRight) && (<View style={styles.row}>
            {!!subtitleLeft && (<Text TextThin-14 Secondary flex style={styles.margin} numberOfLines={1}>
                {subtitleLeft}
              </Text>)}
            {!!subtitleRight &&
                (subtitleLeft ? (<Text NumbersThin-14 Secondary>
                  {subtitleRight}
                </Text>) : (<Text NumbersThin-14 Secondary flex right>
                  {subtitleRight}
                </Text>))}
          </View>)}
      </View>
      {!noBottomLine && <View style={[styles.separator, noPaddingHorizontal && styles.noPaddingHorizontal]}/>}
    </>);
};
const styles = StyleSheet.create({
    container: {
        paddingVertical: rem(16),
        paddingHorizontal: rem(16),
    },
    noPaddingHorizontal: {
        paddingHorizontal: 0,
        marginLeft: 0,
    },
    row: {
        flexDirection: 'row',
        alignItems: 'center',
    },
    separator: {
        height: 1,
        marginLeft: rem(16),
        backgroundColor: '#F2F4F7',
    },
    margin: {
        marginRight: rem(8),
    },
});
export default memo(RowAmount);
